import axios from "axios";

const state = {
  isLoggedIn: undefined,
  isCheckingLogin: true,
  isLoggingOut: false,
  name: "",
  properties: [],
  id: "",
  property: null,
  prevPath: null,
};

const getters = {

};

const mutations = {
  updateLogin (state, params) {
    // console.log(params);
    if (params.isCheckingLogin !== undefined) {
      state.isCheckingLogin = params.isCheckingLogin;
    }

    if (params.isLoggedIn !== undefined) {
      state.isLoggedIn = params.isLoggedIn;
    }

    if (params.name !== undefined) {
      state.name = params.name;
    }

    if (params.properties !== undefined) {
      state.properties = params.properties;
    }

    if (params.id !== undefined) {
      state.id = params.id;
    }

    if (params.isLoggingOut !== undefined) {
      state.isLoggingOut = params.isLoggingOut;
    }
  },
  updateProperty (state, params) {
    if (params.property) {
      state.property = params.property;
    }
  },
  updatePrevPath (state, path) {
    if (path) {
      state.prevPath = path;
    }
  },
};

const actions = {
  checkLogin ({ commit, dispatch }) {
    commit('updateLogin', {
      isCheckingLogin: true,
    });

    axios.get('/api/users/session/admin/read')
      .then((response) => {
        let selPropertyId = window.localStorage.getItem('property');
        if (selPropertyId != null) {
          response.data.user.properties.forEach((property) => {
            if (property.id == selPropertyId) {
              dispatch('setProperty', { property: property });
            }
          });
        }
        commit('updateLogin', {
          isCheckingLogin: false,
          isLoggedIn: response.data.loggedIn == true,
          name: response.data.user.name,
          properties: response.data.user.properties,
          id: response.data.user.id,
        });
      })
      .catch(() => {
        commit('updateLogin', {
          isCheckingLogin: false,
          isLoggedIn: false
        });
      });
  },
  logout ({ commit }) {
    axios.get('/api/users/session/delete')
      .then(() => {
        commit('updateLogin', {
          isLoggingOut: true,
          isLoggedIn: false,
        });
      })
      .catch(() => {
      });
  },
  setProperty ({ commit }, params) {
    window.localStorage.setItem('property', params.property.id);
    axios.defaults.params = {};
    axios.defaults.params['apiKey'] = params.property.apiKey;
    commit('updateProperty', {
      property: params.property,
    });
  },
  setPrevPath ({ commit }, path) {
    commit('updatePrevPath', path);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
